import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactForm, Faq } from '@core/models/interfaces/contact/contact';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private __httpClient: HttpClient) {}

  sendContact(filedValue: ContactForm): Observable<any> {
  return  this.__httpClient.post<ContactForm>(`${environment.url}contacts`, {
      data: filedValue,
    });
  }

  getFAQS(): Observable<Faq[]> {
    return this.__httpClient.get<Faq>(`${environment.url}faqs`).pipe(
      map((res: any) => res.data)
    );
  }
}
